import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BatchTestBriefDto } from '../../../../services/slurry.service';

@Component({
  selector: 'app-slurry-test-output-summary',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './slurry-test-output-summary.component.html',
  styleUrls: ['./slurry-test-output-summary.component.css']
})
export class SlurryTestOutputSummaryComponent {
  @Input() output: BatchTestBriefDto | null = null;
  @Input() outputs: BatchTestBriefDto[] | null | undefined = null;
  @Input() title = 'Output Summary';
  @Input() recordLabel = 'Record Output';
  @Input() reviewLabel = 'Review';
  @Input() recordBlockedReason = '';
  @Input() reviewBlockedReason = '';

  @Output() record = new EventEmitter<void>();
  @Output() review = new EventEmitter<void>();
  @Output() reviewOutput = new EventEmitter<BatchTestBriefDto>();
  @Output() blockedActionClick = new EventEmitter<string>();

  get recordBlocked(): boolean {
    return !!this.recordBlockedReason;
  }

  get reviewBlocked(): boolean {
    return !!this.reviewBlockedReason;
  }

  get summaryOutputs(): BatchTestBriefDto[] {
    if (this.outputs?.length) {
      return this.outputs;
    }

    return this.output ? [this.output] : [];
  }

  statusTextFor(output: BatchTestBriefDto | null | undefined): string {
    const status = output?.status;
    const statusName = output?.statusName?.trim();
    const statusNameMap: Record<string, string> = {
      started: 'InProgress',
      inprogress: 'InProgress',
      accepted: 'Approved',
      approved: 'Approved',
      rejected: 'Rejected',
      needretake: 'Repeat',
      failed: 'Failed',
      finished: 'Completed',
      completed: 'Completed',
      submitted: 'Completed',
      cancelled: 'Cancelled'
    };

    if (statusName) {
      return statusNameMap[statusName.toLowerCase().replace(/\s+/g, '')] ?? statusName;
    }

    const map: Record<number, string> = {
      1: 'InProgress',
      2: 'Approved',
      3: 'Rejected',
      4: 'Repeat',
      5: 'Failed',
      6: 'Completed',
      7: 'Cancelled'
    };

    return status == null ? '--' : (map[status] ?? String(status));
  }

  get statusText(): string {
    return this.statusTextFor(this.output);
  }

  reviewedByTextFor(output: BatchTestBriefDto | null | undefined): string {
    return output?.reviewedBy || '--';
  }

  get reviewedByText(): string {
    return this.reviewedByTextFor(this.output);
  }

  handleRecordClick(event: Event): void {
    event.stopPropagation();
    if (this.recordBlocked) {
      return;
    }

    this.record.emit();
  }

  handleReviewClick(event: Event): void {
    event.stopPropagation();
    if (this.reviewBlocked) {
      return;
    }

    this.review.emit();
  }

  handleReviewOutputClick(event: Event, output: BatchTestBriefDto): void {
    event.stopPropagation();
    if (this.reviewBlocked) {
      return;
    }

    this.reviewOutput.emit(output);
    this.review.emit();
  }

  handleBlockedClick(event: Event, reason: string | null | undefined): void {
    if (!reason) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.blockedActionClick.emit(reason);
  }
}
